import type { RouteTransfer } from '@/types/RouteTransferType';
import { isPaymentLinksCurrencyEnabled } from '@/shared/inswitch/utils/inswitch.util';
import { resolveAllowedPaymentLinksCurrencies } from '@/shared/inswitch/utils/paymentLinksCurrencies.util';

/**
 * Verifica si el usuario tiene al menos una wallet con una moneda habilitada por backend para Links de Cobro.
 * Cruza las wallets reales del usuario con las monedas permitidas por su país (falla cerrado ante un
 * país no mapeado) y el flag `thirdPartyPayment === 'BOTH'` del método InSwitch correspondiente.
 * Resuelve la brecha entre el check a nivel país (guard/botón) y las wallets reales del usuario.
 * @param routes - Lista de rutas de transferencia del store.
 * @param wallets - Wallets reales del usuario, cada una con su moneda.
 * @param userCountry - Código alpha-2 del país de origen de la empresa.
 * @returns true si al menos una wallet tiene una moneda permitida y habilitada por backend.
 */
export function hasUserEnabledPaymentLinksWallet(
  routes: RouteTransfer[],
  wallets: { currency: string }[],
  userCountry: string
): boolean {
  const allowedCurrencies = resolveAllowedPaymentLinksCurrencies(userCountry);
  return wallets.some(
    (w) => allowedCurrencies.includes(w.currency) && isPaymentLinksCurrencyEnabled(routes, w.currency)
  );
}
